/**
 * Runtime config loaded from appsettings.json (next to index.html after build).
 * Change API_BASE_URL in appsettings.json on the server without rebuilding.
 */
import defaultConfig from './config.json';

let _config = null;

const getAppSettingsPath = () => {
  const url = new URL('appsettings.json', window.location.href);
  return url.href;
};

export const loadConfig = () => {
  if (_config) return Promise.resolve(_config);
  const path = getAppSettingsPath();
  return fetch(path, { cache: 'no-store' })
    .then((res) => {
      if (!res.ok) throw new Error(`Config load failed: ${res.status}`);
      return res.json();
    })
    .then((data) => {
      _config = {
        API_HEADDERS: data.API_HEADDERS || defaultConfig.API_HEADDERS,
        API_BASE_URL: data.API_BASE_URL != null ? data.API_BASE_URL : defaultConfig.API_BASE_URL
      };
      return _config;
    })
    .catch((err) => {
      console.warn('Using default config (appsettings.json not found or invalid):', err.message);
      _config = defaultConfig;
      return _config;
    });
};

export const getConfig = () => {
  if (!_config) {
    throw new Error('Config not loaded. Ensure loadConfig() is called before getConfig().');
  }
  return _config;
};
